@if (loading()) {
  <div class="map-spinner">
    <div></div>
    <div></div>
    @if (label()) {
      <span class="map-spinner__text">{{ label() | translate }}...</span>
    }
  </div>
}
